import { Breadcrumbs } from "@/components/layout/Breadcrumbs";

interface AppFooterProps {
  version: string | undefined;
}

export function AppFooter({ version }: AppFooterProps) {
  return (
    <footer className="flex h-8 shrink-0 items-center gap-4 border-t border-border bg-card px-4">
      <Breadcrumbs />
      <div className="hidden shrink-0 items-center gap-2 text-[11px] text-muted-foreground sm:flex">
        <span>Built with Nymbl LLC | Property of Prominent Builders</span>
        {version && (
          <>
            <span className="opacity-40">·</span>
            <span className="font-mono">v{version}</span>
          </>
        )}
      </div>
    </footer>
  );
}
